import React from 'react';
import { connect } from 'react-redux';

import { clearUtilisateurValue } from 'store/utilisateur/utilisateursActions';

import { fetchInterlocuteursSAVAdministration } from 'utils/fetchers';
import { postInterlocuteurSAV } from 'utils/posters';
import { deleteInterlocuteurSAV } from 'utils/posters';


import AdministrationInterlocuteursSAV from './AdministrationInterlocuteursSAV';


class AdministrationInterlocuteursSAVContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            interlocuteursSAV: null,
            departements: null,
            magasins: null,
            utilisateurs: null,
        };
    }

    async componentDidMount() {

        var infos = await this.props.fetchInterlocuteursSAVAdministration();

        this.setState(
            {
                interlocuteursSAV: infos.interlocuteursSAV,
                departements: infos.departements,
                magasins: infos.magasins,
                utilisateurs: infos.utilisateurs,
            });

    }

    componentWillUnmount() {
        this.props.clearUtilisateurValue("administrationInterlocuteursSAV");
    }


    handleChangeUtilisateur = async (type, code, codeATC, id, codePO, nom, prenom) => {

        if (id !== 0) {

            var postReponse = await this.props.postInterlocuteurSAV({ type, code, codeATC, codePOInterlocuteurSAV: codePO });

            if (!postReponse.error) {
                // Modification de l'état en utilisant la réponse ie :   Object { id: 3, type: 0, code: "03", codeATC: '', codePOInterlocuteurSAV: "AGB" }

                let utilisateurs = [...this.state.utilisateurs];

                let utilisateur = utilisateurs.find(x => x.codePO === postReponse.codePOInterlocuteurSAV);
                if (!utilisateur) {
                    utilisateurs.push({ avatar: [], codePO: codePO, id: id, nom: nom, prenom: prenom });
                }

                let interlocuteursSAV = this.state.interlocuteursSAV.filter(x => !(x.type === type && x.code === code && x.codeATC === codeATC));
                interlocuteursSAV.push(postReponse);

                this.setState(
                    {
                        ...this.state,
                        interlocuteursSAV: interlocuteursSAV,
                        utilisateurs: utilisateurs
                    });

            }
        }
        this.props.clearUtilisateurValue("administrationInterlocuteursSAV");
    };

    // Valable uniquement pour les magasins
    handleChangeATC = async (type, code, codeATC, newCodeATC) => {

        if (codeATC === '_NEW') {

            var postReponse = await this.props.postInterlocuteurSAV({ type, code, codeATC: newCodeATC, codePOInterlocuteurSAV: '' });

            if (!postReponse.error) {
                // Modification de l'état en utilisant la réponse ie :   Object { id: 3, type: 0, code: "03", codeATC: '', codePOInterlocuteurSAV: "AGB" }

                let interlocuteursSAV = this.state.interlocuteursSAV.filter(x => x.codeATC !== "_NEW");
                interlocuteursSAV.push(postReponse);

                console.log(interlocuteursSAV);

                this.setState(
                    {
                        ...this.state,
                        interlocuteursSAV: interlocuteursSAV
                    });

            }
        }
    };
    
    // Valable uniquement pour les magasins
    handleCancelChangeATC = () => {

        let interlocuteursSAV = this.state.interlocuteursSAV.filter(x => x.codeATC !== "_NEW");

        this.setState(
            {
                ...this.state,
                interlocuteursSAV: interlocuteursSAV
            });
    };


    handleDeleteInterlocuteurSAV = async (interlocuteurSAV) => {

        if (interlocuteurSAV.id !== 0) {

            var deleteReponse = await this.props.deleteInterlocuteurSAV(interlocuteurSAV);

            if (!deleteReponse.error) {

                this.setState(
                    {
                        ...this.state,
                        interlocuteursSAV: this.state.interlocuteursSAV.filter(x => x.id !== interlocuteurSAV.id)
                    });

            }
        }
    };


    handleDeleteInterlocuteurSAVDepartementATC = async (interlocuteurSAV) => {

        if (interlocuteurSAV.id !== 0) {

            var postReponse = await this.props.postInterlocuteurSAV({ type: interlocuteurSAV.type, code: interlocuteurSAV.code, codeATC: interlocuteurSAV.codeATC, codePOInterlocuteurSAV: '' });

            if (!postReponse.error) {
                // Modification de l'état en utilisant la réponse ie :   Object { id: 3, type: 0, code: "03", codeATC: 'DEL', codePOInterlocuteurSAV: '' }

                let interlocuteursSAV = this.state.interlocuteursSAV.map(x => x.id !== interlocuteurSAV.id ? { ...x } : { ...x, codePOInterlocuteurSAV: ''});

                this.setState(
                    {
                        ...this.state,
                        interlocuteursSAV: interlocuteursSAV
                    });

            }

        }
    };

    // Spécifique aux départements
    handleAddATC = (code) => {

        this.setState(
            {
                ...this.state,
                interlocuteursSAV: [...this.state.interlocuteursSAV, { id: 0, type: 1, code, codeATC: '_NEW', codePOInterlocuteurSAV: ''}]
            });

    };

    render() {
        const { interlocuteursSAV, departements, magasins, utilisateurs } = this.state;

        return (
            <AdministrationInterlocuteursSAV
                interlocuteursSAV={interlocuteursSAV}
                departements={departements}
                magasins={magasins}
                utilisateurs={utilisateurs}

                onChangeUtilisateur={this.handleChangeUtilisateur}
                onDeleteInterlocuteurSAV={this.handleDeleteInterlocuteurSAV}
                onDeleteInterlocuteurSAVDepartementATC={this.handleDeleteInterlocuteurSAVDepartementATC}
                onAddATC={this.handleAddATC}
                onChangeATC={this.handleChangeATC}
                onCancelChangeATC={this.handleCancelChangeATC}
            />
        );
    }
}


const mapDispatchToProps = {
    fetchInterlocuteursSAVAdministration,
    clearUtilisateurValue,
    postInterlocuteurSAV,
    deleteInterlocuteurSAV  

};

export default connect(null, mapDispatchToProps)(AdministrationInterlocuteursSAVContainer);